import React from "react";
import ScrollToTop from "./components/ScrollToTop";
import FooterNew from "./containers/FooterNew";
import { ToastContainer } from "react-toastify";
import { SnackbarProvider } from "notistack";
import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";
import Header from "./components/Header";

function Layout(){

    return(
        <>
            <ScrollToTop />
            <Outlet />
            <ToastContainer />
            <SnackbarProvider />
            <Toaster />
            <FooterNew />
        </>
    );
}

export default Layout;